import React, { useEffect, useState } from 'react'
import "./OrderDetailscontainer.css"
import { Col, Container, Modal, Row, Toast, ToastContainer } from 'react-bootstrap'
import AddressBox from '../AddressBox/AddressBox'
import { useSelector } from 'react-redux';
import axios from 'axios';
import StarRatings from 'react-star-ratings';
function OrderDetailscontainer({ order }) {
    const [show, setShow] = useState(false);
    const [alert, setAlert] = useState('');
    const [rating, setRating] = useState();
    const [comment, setComment] = useState();

    const [showRatingModel, setShowRatingModel] = useState(false);
    const userinfo = useSelector((state) => state);
  const { currentLocal } = useSelector((state) => state.currentLocal);

console.log(order);


    // useEffect(() => {
    //     if (order?.status === "DELIVERED") {
    //         setShowRatingModel(true)
    //     }
    // }, [order])
    console.log(order?.status);
    

    return (
        <div className='order_details_container'>
                        <ToastContainer
                className="p-3"
                position={'bottom-end'}
                style={{ zIndex: 1000000000000000000, position: 'fixed' }}
                backgroundColor={'success'}
            >
                <Toast onClose={() => setShow(false)} show={show} bg={"success"}delay={5000} autohide>
                    <Toast.Header className='d-flex justify-content-between border-0 py-0 bg-transparent border-bpttom'>
                        <p></p>
                        <img
                            src="holder.js/20x20?text=%20"
                            className="rounded me-2"
                            alt=""
                        />
                    </Toast.Header>
                    <Toast.Body className='text-center text-white'>{alert}</Toast.Body>
                </Toast>
            </ToastContainer>
            <Modal
                show={showRatingModel}
                onHide={() => setShowRatingModel(false)}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className='edit_model'
                scrollable
            >
                <Modal.Header closeButton className='py-1 border-bottom-0'>

                </Modal.Header>
                <Modal.Body>

                    {/* {order && order.items.map((item) => {
                        
                        return (
                            <div className='border-bottom py-2'>
                                <form onSubmit={async(e)=>{
                                    e.preventDefault();
                                          await axios
                                          .post(`https://nanosoft.technology/outlaw/api/reviews`, {
                                            productId: String(item.id),
                                            rating:rating,
                                            comment:comment
                                          },{
                                            headers:{
                                                Authorization: `Bearer ${userinfo.auth.access_token}`

                                            }
                                          })
                                          .then(async (res) => {
                                            setShow(true)
                                            setAlert('Review added successfully')
                                            setComment('')
                                            setRating()
                                            setShowRatingModel(false)
                                          })
                                          .catch((error) => {
                                    
                                            setShow(true)
                                            setAlert(error.response.data.error)
                                    
                                      
                                          });
                                }}>
                                    <div>
                                        <p className='mb-1'>Name:<span className='text-muted mx-1'>{item.name}</span></p>
                                        <p className='mb-1'>Color:<span className='text-muted mx-1'>{item.color}</span></p>
                                        <p className='mb-1'>Size:<span className='text-muted mx-1'>{item.size}</span></p>
                                        <p className='mb-1'>Quantity:<span className='text-muted mx-1'>{item.quantity}</span></p>


                                    </div>
                                    <StarRatings
                                        rating={rating}
                                        starRatedColor="#e9ba17"
                                        numberOfStars={5}
                                        name='rating'
                                        isSelectable={true}
                                        starDimension="25px"
                                        starSpacing="2px"
                                        changeRating={(newRating, name) => setRating(newRating)}

                                    />
                                    <textarea 
                                    placeholder='Your comment '
                                     className='mb-3 bg-muted py-1 px-2 w-100 border-0 mt-4'
                                        style={{ backgroundColor: '#F1F4FE', borderRadius: '7px' }}
                                        value={comment}
                                        onChange={(e)=>setComment(e.target.value)}
                                    >

                                    </textarea>
                                    <div className='w-100 d-flex justify-content-center'>
                                        <button className='w-50 bg-primary text-white py-2 ' type='submit'>Rate</button>

                                    </div>
                                </form>
                            </div>
                        )
                    })} */}

                </Modal.Body>
                {/* <Modal.Footer className='justify-content-between'>
          <div className="d-flex">
            <input type="checkbox" style={{ width: "10%", marginRight: "7px" }}
              checked={isChecked} // Controlled checkbox
              onChange={toggleCheckbox} // Toggle the state when checkbox is clicked
            />
            Make Default</div>
          <button type="submit" className=" edit_btn " onClick={sendData}>Save changes</button>

        </Modal.Footer> */}
            </Modal>
            <h3>{currentLocal.home.TrackOrder}: {order && order.order_no} </h3>
           <div className='d-flex align-items-centser mb-4 date_container'>
                <p className='mb-0 order_date mx-1'>
                    <span className='order_date_title'>{currentLocal.home.orderdate}:</span>
                    <span className='order_date_value'>{order && order?.created_at?.substring(0, 10)}</span>
                </p>
                |
                <p className='mb-0 estimated_date mx-1'>
                    {currentLocal.home.Estimateddelivery}:{`5 ${currentLocal.home.Days} `}
                </p>
            </div>
             <div className='my-5 pt-5' style={{ position: 'relative' }}>
                <div className=''>
                    <p style={order?.status?.id ==3 ? { color: "rgb(13, 110, 253)" } : { color: "gray" }} className={currentLocal.language=="English"?'PROCESSING_status':"ar_PROCESSING_status"}>{currentLocal.home.proccing}</p>
                    <p style={order?.status?.id === 4 ? { color: "rgb(13, 110, 253)" } : { olor: "gray" }} className={currentLocal.language=="English"?'SHIPPED_status':'ar_SHIPPED_status'}>{currentLocal.home.shipped}</p>
                    <p style={order?.status?.id === 5 ? { color: "rgb(13, 110, 253)" } : { olor: "gray" }} className={currentLocal.language=="English"?'Delivered_status':'ar_Delivered_status'}>{currentLocal.home.delivered} </p>
                </div>
                <div className='line'>

                </div>
                <div className={currentLocal.language=="English"?'PROCESSING_state':'ar_PROCESSING_state'} style={order?.status?.id ==3 ? { backgroundColor: "rgb(13, 110, 253)" } : { backgroundColor: "gray" }}> </div>
                <div className={currentLocal.language=="English"?'shipping_state':"ar_shipping_state"} style={order?.status?.id ===4 ? { backgroundColor: "rgb(13, 110, 253)" } : { backgroundColor: "gray" }}> </div>
                <div className={currentLocal.language=="English"?'dilivered_state':"ar_dilivered_state"} style={order?.status?.id === 5 ? { backgroundColor: "rgb(13, 110, 253)" } : { backgroundColor: "gray" }}> </div>
            </div>
            <Container fluid className='px-0' >
                <Row>
                    <Col md={6}>

                        <AddressBox defaultState={false}
                            item={order&&order.address}

                        />

                    </Col>
                    <Col md={6}>
                        <div className='adress_box_container'>
                            <div className='fw-bold mb-4'>

                                {currentLocal.home.Payment}
                            </div>
                            <p>{order && order.payment_method=="cash"?currentLocal.home.Cash:order.payment_method}</p>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default OrderDetailscontainer